<script src="//editor.unlayer.com/embed.js"></script>
<div class="wrapper-template">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a
            routerLink="/dashboard/email-template"
            class="btn btn-back"
            [attr.aria-label]="'Back' | translate"
          >
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Automated Emails' | translate">
            {{ "Update Email Template" | translate }}
          </div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block">
          <button
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="getStatus()"
            class="btn btn-red"
            (click)="revertTemplate()"
          >
            <i class="fi fi-rs-undo"></i>
            {{ "Revert" | translate }}
          </button>
          <button
            [ngClass]="{ 'is-loading': loading }"
            class="ml-2 btn btn-primary"
            (click)="exportHtml()"
          >
            {{ "Save" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="section-action">
    <div
      [formGroup]="tempForm"
      class="d-flex flex-column flex-sm-row align-items-sm-center"
    >
      <span class="mr-2">{{ "Template Name" | translate }}</span>
      <div class="d-flex flex-column flex-sm-row">
        <div class="form-group mb-0">
          <input
            type="text"
            class="form-control"
            formControlName="template_name"
            placeholder="{{ 'Template name...' | translate }}"
            [ngClass]="{ 'form-control-error': errorStatus }"
          />
          <span *ngIf="errorStatus" style="color: #eb5757">{{
            errorMsg | translate
          }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-sm-row align-items-sm-center">
      <!-- <button class="btn btn-primary" (click)="saveDesign()">Save Design</button> -->
    </div>
  </div>

  <div class="loading-spinner col-12 mt-5" *ngIf="loading">
    <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
  </div>

  <div
    class="section-main"
    [ngClass]="{ 'is-loading': loading }"
    *ngIf="!loading"
  >
    <email-editor
      [minHeight]="'calc(100vh - 300px)'"
      [options]="emailOption"
    ></email-editor>
  </div>

  <form
    id="media-selector-event-transport"
    (setImageInputID)="handleSetImageInputID($event)"
  ></form>
  <media-selector
    id="media-selector-embed"
    [(mediaID)]="mediaID"
    [(imgURL)]="imageURL"
    (mediaChanged)="handleMediaChanged($event)"
    class="d-none"
  ></media-selector>
</div>
